import React from 'react';
import { Check, X } from 'lucide-react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
export function ForWhomSection() {
  return <Section className="bg-stone-50" data-id="element-85">
      <h2 className="text-3xl font-bold text-navy text-center mb-12" data-id="element-86">
        ¿Para quién es?
      </h2>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-87">
        {/* YES Card */}
        <Card className="border-t-4 border-t-green bg-white" data-id="element-88">
          <h3 className="text-xl font-bold text-green mb-6 flex items-center gap-2" data-id="element-89">
            <Check className="w-6 h-6" data-id="element-90" />
            Es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-91">
            {['Tienes un perro adulto (1–7 años)', 'Quieres dejar croquetas como base o reducirlas fuertemente', 'Te importa hacerlo bien sin complicarte', 'Quieres una ruta práctica, estilo checklist'].map((item, i) => <li key={i} className="flex items-start gap-3 text-navy/80" data-id="element-92">
                <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-green flex-shrink-0" data-id="element-93" />
                <span data-id="element-94">{item}</span>
              </li>)}
          </ul>
        </Card>

        {/* NO Card */}
        <Card className="border-t-4 border-t-red/50 bg-stone-100/50" data-id="element-95">
          <h3 className="text-xl font-bold text-navy/60 mb-6 flex items-center gap-2" data-id="element-96">
            <X className="w-6 h-6" data-id="element-97" />
            No es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-98">
            {['Tu perro necesita dieta terapéutica por diagnóstico (consulta vet)', 'Buscas BARF avanzado desde el día 1', 'Quieres 20 ingredientes y suplementos en la primera semana'].map((item, i) => <li key={i} className="flex items-start gap-3 text-navy/60" data-id="element-99">
                <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-navy/30 flex-shrink-0" data-id="element-100" />
                <span data-id="element-101">{item}</span>
              </li>)}
          </ul>
        </Card>
      </div>
    </Section>;
}